export const SAMPLE_COLUMNS_NAME_LOTTERY_DETAILS = [
	'pool_type',
	'display_start_at_ist',
	'start_at_ist',
	'end_at_ist',
	'result_declared_at_ist',
	'display_end_at_ist',
	'tickets_ttl_in_days',
	'lottery_number_length',
	'lottery_start_number',
	'draw_strategy',
	'meta'
];

export const SAMPLE_COLUMNS_VALUES_LOTTERY_DETAILS = [
	'SUPER_SIX',
	'2025-02-27 15:15:00',
	'2025-02-27 15:30:00',
	'2025-02-27 21:30:00',
	'2025-02-27 22:30:00',
	'2025-02-27 23:30:00',
	'7',
	'8',
	'10000001',
	`${JSON.stringify({
		'1': {
			expression: 'R1',
			prize: {
				type: 'KIND',
				reward: 'THAR'
			}
		},
		'2': {
			expression: 'R2',
			prize: {
				type: 'CASH',
				reward: 1000,
				transaction_type: 'winnings'
			},
			rules: {
				R2: {
					number: '2'
				}
			}
		}
	})}`,
	`${JSON.stringify({
		matches: [
			{
				teams: [
					{
						name: 'IND'
					},
					{
						name: 'ENG'
					}
				]
			},
			{
				teams: [
					{
						name: 'MI'
					},
					{
						name: 'CSK'
					}
				]
			}
		]
	})}`
];

export const defaultData = {
	lotteryType: 'SUPER_SIX',
	actionName: 'end_match'
};

export const uploadCsvURI = '/dashboard/uploadCsvForLotteryDashboard/lottery-uploadCsv-getUploadCsvPage';
export const performSelectedActionURI = '/dashboard/performSelectedAction/lottery-lotteryActions-getLotteryActions';

export const LOTTERY_POOL_ACTION_OPTIONS = [
	{ label: 'End Match', id: 'end_match' },
	{ label: 'Abort Lottery', id: 'abort_lottery' }
];

export const csvFailedMessage = 'Error: CSV upload failed, please try again. ! Error: ';
export const csvUploadSuccessMessage = 'CSV uploaded';
export const allertType = 'error';
export const actionPerformedSuccessMessage = 'Action performed successfully';
